import React from 'react';
import { RhNumberField } from '../../../../../../../dum';
import { CURRENT_GROUP_PRICE, CURRENT_KILO_PRICE } from '../../product-form';
import { useFormContext } from 'react-hook-form';
import { FIELD_LABELS, shortLabel } from '../../../../../../../../helpers';

export function CurrentGroupPriceInput() {
    const rx = useFormContext();

    return (
        <RhNumberField
            name={CURRENT_GROUP_PRICE}
            label={shortLabel(FIELD_LABELS.current_group_price)}
            onChange={() => {
                void rx.trigger(CURRENT_KILO_PRICE);
            }}
        />
    );
}
